<template>
	<div class="add-box">
		<el-dialog v-model="dialogVisible" :title="title" width="40%" :before-close="handleClose">
			<el-form ref="form" :model="Dform" :rules="rules" label-width="80px">
				<el-row>
					<el-form-item label="学校" prop="region">
						<el-select v-model="Dform.region" filterable placeholder="请选择学校" @change="schoolClick" @click="schoolPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolList"
								:key="item.value"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="school_loading"><text>加载中...</text></div> -->
					</el-form-item>
					<el-form-item label="用户名" prop="username" v-if="this.titleValue == '学校管理员修改' || this.titleValue == '教职工修改' || this.titleValue == '年级管理员修改' || this.titleValue == '班级管理员修改'">
						<el-input v-model="Dform.username" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="用户名" prop="username" v-else>
						<el-input v-model="Dform.username"></el-input>
					</el-form-item>
					<!-- <el-form-item label="年级 " prop="classes" v-if="title != '新增学校管理员' &&  title != '新增教职工' && title != '学校管理员修改' && title != '教职工修改'">
						<el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick" @click="gradePost()">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataList"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="设置密码" prop="setPassword">
						<el-input v-model="Dform.setPassword" type="password"></el-input>
					</el-form-item>

					<!-- <el-form-item label="班级" prop="classes2" v-if="title == '新增班级管理员' || title == '班级管理员修改'">
						<el-select v-model="Dform.classes2" filterable placeholder="请选择班级" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in classList"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="确认密码" prop="confirmPassword">
						<el-input v-model="Dform.confirmPassword" type="password"></el-input>
					</el-form-item>

					<el-form-item label="姓名" prop="name">
						<el-input v-model="Dform.name"></el-input>
					</el-form-item>
					<el-form-item label="教师编号" prop="teacherNumber">
						<el-input v-model="Dform.teacherNumber"></el-input>
					</el-form-item>

					<el-form-item label="手机" class="mobileStyle" prop="handset">
						<el-input v-model="Dform.handset"></el-input>
					</el-form-item>
					<el-form-item label="职称" prop="positionalTitles">
						<el-input v-model="Dform.positionalTitles"></el-input>
					</el-form-item>

					<el-form-item label="年龄" prop="age">
						<el-input v-model="Dform.age"></el-input>
					</el-form-item>

					<el-form-item label="电话">
						<el-input v-model="Dform.telephone"></el-input>
					</el-form-item>
					<el-form-item label="地址">
						<el-input v-model="Dform.address"></el-input>
					</el-form-item>
					<el-form-item label="性别">
						<el-radio-group v-model="Dform.sex">
							<el-radio label="男"></el-radio>
							<el-radio label="女"></el-radio>
						</el-radio-group>
					</el-form-item>
				</el-row>

				<el-row>
					<el-form-item label="通行策略" prop="strategy">
						<el-select v-model="Dform.strategy" filterable placeholder="请选择通行策略" multiple>
							<el-option v-for="item in strategy" :key="item.value" :label="item.strategyName"
								:value="item.strategyId"></el-option>
						</el-select>
					</el-form-item>
				</el-row>
				<!-- <el-row >
                    <el-form-item label="班级" prop="classes" v-if="title != '新增学校管理员' && title != '学校管理员修改'">
                        <el-select v-model="Dform.classes" filterable placeholder="请选择年级" @change="classClick">
                            <el-option :label="item.name" :value="item.id" v-for="item in gradeDataList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="classes2" v-if="title == '新增班级管理员' || title == '班级管理员修改'">
                        <el-select v-model="Dform.classes2" filterable placeholder="请选择班级">
                            <el-option :label="item.name" :value="item.id" v-for="item in classList" :key="item.value" ></el-option>
                        </el-select>
                    </el-form-item>
                </el-row> -->
				<!-- <el-row>
                    <el-form-item label="设置密码" prop="setPassword">
                        <el-input v-model="Dform.setPassword" type="password" ></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input v-model="Dform.confirmPassword" type="password" ></el-input>
                    </el-form-item>
                </el-row> -->
				<!-- <el-row>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="Dform.name" ></el-input>
                    </el-form-item>
                    <el-form-item label="教师编号" prop="teacherNumber">
                        <el-input v-model="Dform.teacherNumber" ></el-input>
                    </el-form-item>
                </el-row> -->
				<!-- <el-row>
                    <el-form-item label="职称" prop="positionalTitles">
                        <el-input v-model="Dform.positionalTitles" ></el-input>
                    </el-form-item>
                    <el-form-item label="年龄" prop="age">
                        <el-input v-model="Dform.age" ></el-input>
                    </el-form-item>
                </el-row> -->
				<!-- <el-row>
                    <el-form-item label="性别" >
                        <el-radio-group v-model="Dform.sex">
                            <el-radio label="男" ></el-radio>
                            <el-radio label="女" ></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="手机" class="mobileStyle" >
                        <el-input v-model="Dform.handset" ></el-input>
                    </el-form-item>
                </el-row>
       -->
				<el-row>
					<!-- <el-form-item label="电话" >
                        <el-input v-model="Dform.telephone" ></el-input>
                    </el-form-item> -->
					<!-- <el-form-item label="地址" >
                        <el-input v-model="Dform.address" ></el-input>
                    </el-form-item> -->
				</el-row>
				<!-- <el-row>
                    <el-form-item label="短信额度" >
                        <el-input v-model="Dform.smsQuota" ></el-input>
                    </el-form-item>
                    <el-form-item label="已用额度" >
                        <el-input v-model="Dform.alreadyUsed" ></el-input>
                    </el-form-item>
                </el-row>
             -->
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="handleClose">返回</el-button>
					<el-button type="primary" class="formClick" @click="submitForm('form')">
						提交
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addTeacherInfo,
		addGrade,
		addClass,
		schoolList,
		gradeList,
		findClassList,
		updateTeacherInfo,
		strategyList
	} from '@/assets/api/renyuan';
	import {
		ElMessage,
		ElLoading
	} from 'element-plus';
	export default {
		props: ['titleValue', 'detailsObj', 'schoolOptions'],
		components: {

		},
		data() {
			return {
				Dform: {
					region: '',
					username: '',
					setPassword: '',
					confirmPassword: '',
					name: '',
					teacherNumber: '',
					positionalTitles: '',
					age: '',
					// postbox: '',
					handset: '',
					telephone: '',
					address: '',
					smsQuota: 0,
					alreadyUsed: 0,
					classes: '',
					classes2: '',
					studentId: '',
					parentsCall: '',
					parentsCall2: '',
					parentsCall3: '',
					sex: '男',
					strategy: [],
					Nfc: '',
					Imei: '',
					international: '',
				},
				dialogVisible: true,
				title: '',
				schoolList: [],
				strategy: [],
				gradeDataList: [],
				classList: [],
				school_loading : false,
				grade_loading : false,
				class_loading : false,
				rules: {
					// imei: [
					//     { required: true, message: '请输入IMEI', trigger: 'blur' },
					// ],
					region: [{
						required: true,
						message: '请选学校',
						trigger: 'change'
					}],
					classes: [{
						required: true,
						message: '请选班级',
						trigger: 'change'
					}],
					classes2: [{
						required: true,
						message: '请选班级',
						trigger: 'change'
					}],
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'change'
					}],
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'change'
					}],
					handset: [{
						required: true,
						message: '请输入手机',
						trigger: 'change'
					}],
				},
			};
		},
		created() {
			this.title = this.titleValue
			if (this.schoolOptions && this.schoolOptions.length) {
				this.schoolList = this.schoolOptions
			}
			if (this.titleValue == '学校管理员修改' || this.titleValue == '教职工修改' || this.titleValue == '年级管理员修改' || this.titleValue == '班级管理员修改') {
				console.log(JSON.stringify(this.detailsObj), '修改页');
				this.Dform.address = this.detailsObj.address // 地址
				this.Dform.age = this.detailsObj.age // 
				this.Dform.confirmPassword = this.detailsObj.checkPassword // 确认密码
				this.Dform.classes2 = this.detailsObj.classId // 班级
				this.Dform.classes = this.detailsObj.gradeId // '年级id'
				this.Dform.region = this.detailsObj.schoolId // 学校id
				this.Dform.teacherNumber = this.detailsObj.code // 编号
				// this.Dform.postbox = this.detailsObj.email // 邮箱
				this.Dform.smsQuota = this.detailsObj.maxSms // 短信额度
				this.Dform.alreadyUsed = this.detailsObj.usedSms // 已用额度
				this.Dform.handset = this.detailsObj.mobile // 手机
				this.Dform.name = this.detailsObj.name // 姓名
				this.Dform.setPassword = this.detailsObj.password
				this.Dform.positionalTitles = this.detailsObj.position
				this.Dform.sex = this.detailsObj.sex == '0' ? '女' : '男' // 性别
				this.Dform.studentId = this.detailsObj.studentNo // 学号
				this.Dform.telephone = this.detailsObj.telephone // 电话
				this.Dform.username = this.detailsObj.username
				if (this.detailsObj.strategyId) {
					let data = [];
					this.detailsObj.strategyId.split(',').forEach((obj) => {
						data.push(parseInt(obj));
					});
					this.Dform.strategy = data
				}
			}
			if (this.titleValue == '年级管理员修改' || this.titleValue == '班级管理员修改') {
				this.schoolClick(1)
			}
			if (this.titleValue == '班级管理员修改') {
				this.classClick(1)
			}
		},
		mounted() {
			if (this.titleValue == '学校管理员修改'  || this.titleValue == '教职工修改' || this.titleValue == '年级管理员修改' || this.titleValue == '班级管理员修改') {
				this.schoolPost();
			}
			
			this.getStrategy();
		},
		methods: {
			classPost(){
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.class_loading = true;
				findClassList(params, this.Dform.classes).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
					this.class_loading = false;
				}).catch((err) => {
					this.class_loading = false;
					console.log(err);
				})
			},
			
			
			classClick(vla) {
				if (vla != 1) {
					this.Dform.classes2 = ''
				}else{
					this.classPost();
				}
			},
			
			gradePost(){
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.grade_loading  = true;
				gradeList(params, this.Dform.region).then((res) => {
					this.grade_loading  = false;
					this.gradeDataList = res.data.data;
					// console.log(res,this.Dform.classes,'年级列表');
				}).catch((err) => {
					this.grade_loading  = false;
					console.log(err);
				})
			},
			

			schoolClick(vla) {
				if (vla != 1) {
					this.Dform.classes = ''
					this.Dform.classes2 = ''
				}else{
					this.gradePost();
				}
			},

			schoolPost(schooName) {
				if (this.schoolList.length > 0) {
					return;
				}
				let params = JSON.parse(localStorage.getItem('user')).id;
				this.school_loading = true;
				schoolList(params).then((res) => {
					// console.log(res,'学校列表');
					this.school_loading = false;
					this.schoolList = res.data.data;
				}).catch((err) => {
					this.school_loading = false;
					console.log(err);
				})
			},
			
			
			submitForm(formName) {
				console.log(this.Dform, this.title);
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log('校验通过');
						if (this.title == '新增学校管理员' || this.title == '新增教职工') {
							this.addTeacherInfo()
							console.log('新增学校管理员');
						} else if (this.title == '新增年级管理员') {
							console.log('新增年级管理员');
							this.addGrade()
						} else if (this.title == '新增班级管理员') {
							console.log('新增班级管理员');
							this.addClass()
						} else if (this.title == '学校管理员修改' || this.title == '教职工修改' || this.title == '年级管理员修改' || this.title == '班级管理员修改') {
							console.log('修改角色');
							this.updateTeacherInfo()
						}
					} else {
						console.log(valid, '校验未通过');
						return false;
					}
				});
			},
			handleClose() {
				this.$emit('addClick')
			},
			updateStudentInfoClick() {
				let params = {
					studentId: this.Dform.studentId,
					classId: this.detailsObj.classId,
					mobileOne: this.Dform.parentsCall,
					mobileTwo: this.Dform.parentsCall2,
					mobileThree: this.Dform.parentsCall3,
				}
				console.log(params, 1111);
				updateStudentInfo(params).then((res) => {
					console.log(res, 4444);
				}).catch((err) => {
					console.log(err, 6666);
				})
			},
			// 学校管理员
			addTeacherInfo() {
				console.log(789);
				let params = {
					address: this.Dform.address, // 地址
					age: this.Dform.age, // 
					checkPassword: this.Dform.confirmPassword, // 确认密码
					// classId: this.Dform.classes2, // 班级
					// gradeId: this.Dform.region, // '年级id'
					schoolId: this.Dform.region, // 学校id
					code: this.Dform.teacherNumber, // 编号
					personType: this.title == "新增学校管理员" ? "1" : "4",//学校管理员/教职工
					// email: this.Dform.postbox, // 邮箱
					maxSms: this.Dform.smsQuota, // 短信额度
					usedSms: this.Dform.alreadyUsed, // 已用额度
					mobile: this.Dform.handset, // 手机
					name: this.Dform.name, // 姓名
					password: this.Dform.setPassword,
					position: this.Dform.positionalTitles,
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别
					// studentName: this.Dform.name, // 姓名
					studentNo: this.Dform.studentId, // 学号
					telephone: this.Dform.telephone, // 电话
					userName: this.Dform.username,
					strategyId: (this.Dform.strategy || []).join(','),
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				addTeacherInfo(params).then((res) => {
					console.log(res, '老师-新增');
					this.$message({
						type: 'success',
						message: '新增成功!'
					});
					this.handleClose()
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			//学校修改
			updateTeacherInfo() {
				let params = {
					address: this.Dform.address, // 地址
					age: this.Dform.age, // 
					checkPassword: this.Dform.confirmPassword, // 确认密码
					classId: this.title == '班级管理员修改' ? this.Dform.classes2 : null, // 班级
					gradeId: this.title == '年级管理员修改' || this.title == '班级管理员修改' ? this.Dform.classes : null, // '年级id'
					schoolId: this.Dform.region, // 学校id
					code: this.Dform.teacherNumber, // 编号
					// email: this.Dform.postbox, // 邮箱
					maxSms: this.Dform.smsQuota, // 短信额度
					usedSms: this.Dform.alreadyUsed, // 已用额度
					mobile: this.Dform.handset, // 手机
					name: this.Dform.name, // 姓名
					password: this.Dform.setPassword,
					position: this.Dform.positionalTitles,
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别
					// studentName: this.Dform.name, // 姓名
					studentNo: this.Dform.studentId, // 学号
					telephone: this.Dform.telephone, // 电话
					username: this.Dform.username,
					id: this.detailsObj.id,
					strategyId: (this.Dform.strategy || []).join(','),
					loginUserId: JSON.parse(localStorage.getItem('user')).id,
				}
				updateTeacherInfo(params).then((res) => {
					console.log(res, '老师-新增');
					this.$message({
						type: 'success',
						message: '修改成功!'
					});
					this.handleClose()
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			// 年级管理员
			addGrade() {
				let params = {
					address: this.Dform.address, // 地址
					age: this.Dform.age, // 
					checkPassword: this.Dform.confirmPassword, // 确认密码
					classId: null,
					gradeId: this.Dform.classes, // '年级id'
					schoolId: this.Dform.region, // 学校id
					code: this.Dform.teacherNumber, // 编号
					// email: this.Dform.postbox, // 邮箱
					maxSms: this.Dform.smsQuota, // 短信额度
					usedSms: this.Dform.alreadyUsed, // 已用额度
					mobile: this.Dform.handset, // 手机
					personType: "2",//年级管理员
					name: this.Dform.name, // 姓名
					password: this.Dform.setPassword,
					position: this.Dform.positionalTitles,
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别
					studentName: this.Dform.name, // 姓名
					studentNo: this.Dform.studentId, // 学号
					telephone: this.Dform.telephone, // 电话
					userName: this.Dform.username,
					strategyId: (this.Dform.strategy || []).join(','),
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				addTeacherInfo(params).then((res) => {
					this.handleClose()
					this.$message({
						type: 'success',
						message: '新增成功!'
					});
					console.log(res);
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			//班级管理员
			addClass() {
				let params = {
					address: this.Dform.address, // 地址
					age: this.Dform.age, // 
					checkPassword: this.Dform.confirmPassword, // 确认密码
					classId: this.Dform.classes2,
					// gradeId: this.Dform.classes2, // '年级id'
					gradeId: this.Dform.classes, // '年级id'
					schoolId: this.Dform.region, // 学校id
					code: this.Dform.teacherNumber, // 编号
					personType: "3",//班级管理员
					// email: this.Dform.postbox, // 邮箱
					maxSms: this.Dform.smsQuota, // 短信额度
					usedSms: this.Dform.alreadyUsed, // 已用额度
					mobile: this.Dform.handset, // 手机
					name: this.Dform.name, // 姓名
					password: this.Dform.setPassword,
					position: this.Dform.positionalTitles,
					sex: this.Dform.sex == '女' ? '0' : '1', // 性别
					// studentName: this.Dform.name, // 姓名
					studentNo: this.Dform.studentId, // 学号
					telephone: this.Dform.telephone, // 电话
					userName: this.Dform.username,
					strategyId: (this.Dform.strategy || []).join(','),
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				addTeacherInfo(params).then((res) => {
					this.handleClose()
					this.$message({
						type: 'success',
						message: '新增成功!'
					});
					console.log(res);
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			
			
			
			getStrategy() {
				let loginid = JSON.parse(localStorage.getItem('user')).id;
				strategyList(loginid).then((res) => {
					this.strategy = res.data.data
					console.log(this.strategy, 'sln88888888888888888888888888');

				}).catch((err) => {
					console.log(err);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},

			openElLoading(text) {
				this.elLoading = ElLoading.service({
					lock: true,
					text: `${text}...`,
					spinner: `
					<div class="custom-loading">
					  <div class="custom-spinner"></div>
					</div> `,
					background: 'rgba(0, 0, 0, 0.7)',
				});
			},

			closeElLoading() {
				if (this.elLoading) {
					this.elLoading.close();
					this.elLoading = null;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.formClick {
		// background-color: #1BC896;;
	}
	
	.loading_view{
		position: absolute;
		padding: 5px;
		background-color: rgba(0, 0, 0, 0.8);
		width: 100%;
		color: white;
		text-align: center;
		border-radius: 5px;
	}
	

	.custom-loading {
		width: 40px;
		height: 40px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.custom-spinner {
		width: 40px;
		height: 40px;
		border: 4px solid #409EFF;
		border-top-color: transparent;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}


	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}



	:deep() {
		.el-dialog__body {
			// height: 75%;
			max-height: 500px;
			// min-height: 350px;        
			overflow: auto;
		}

		.el-input--small {
			width: 250px;
		}

		.el-select .el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-form-item--small .el-form-item__label {
			height: 35px;
			line-height: 35px;
		}

		.el-input__inner {
			height: 35px;
			line-height: 35px;
		}

		.el-radio.el-radio--small .el-radio__inner {
			width: 14px;
			height: 14px;
		}

		.el-input__wrapper {
			height: 35px;
			line-height: 35px;
		}

		.el-date-editor.el-input,
		.el-date-editor.el-input__wrapper {
			height: 35px !important;
		}

		.el-select--small .el-select__wrapper {
			width: 250px;
			height: auto;
			min-height: 35px;
		}

		.mobileStyle {
			// width: 345px;
			// margin-left: 150px;

		}
	}
</style>